
<template>
  <div class="promotionMap-component">
    <div class="top-info">
        <p class="text">授权销售服务门店<span class="number">{{all_store_list_count}}</span>家</p>
        <button class="map-model" @click="goPage('list')">门店列表</button>
    </div>
    <div id="allmap" class="map"></div>
    <div class="reset" @click="goPage('reset')">
        <span class="ico ico-icon_51"></span>
    </div>
    <div class="enlarge">
        <span class="ico ico-icon_53" @click="goPage('map')"></span>
    </div>
  </div>
</template>

<script >
import {
    getPromotionStoreInfo
} from '@/models/custom'
export default {
    name: 'promotionMap',
    props: {
        position: {
            type: Object,
            default: () => {
                return {
                    longitude: '',
                    latitude: '',
                }
            }
        },
        topictype: {
            type: String,
        }
    },
    watch: {
        position: {
            handler: function (newValue, oldValue) {
                const { latitude, longitude } = newValue
                if (latitude && longitude) {
                    this.isPosition = true
                } else {
                    this.isPosition = false
                }
                this.$nextTick(() => {
                    this.initBaiduMap()
                })
            },
            deep: true,
            immediate: true
        },
    },
    data () {
        return {
            isPosition: false, // 是否获取当前位置

            allStoreList: [], // 全部门店
            all_store_list_count: '', // 全部门店数量
            // 百度地图
            baidu_map: null, // 地图
            map_icon: {
                selfIcon: new BMap.Icon('https://image.carisok.com/images/icon_map_self.png?x-oss-process=image/resize,w_22,h_30', new BMap.Size(22, 30)), // eslint-disable-line
                ohterIcon: new BMap.Icon('https://image.carisok.com/images/icon_map_other.png?x-oss-process=image/resize,w_44,h_57', new BMap.Size(44, 57)), // eslint-disable-line
                nearIcon: new BMap.Icon('https://image.carisok.com/images/icon_map_near.png?x-oss-process=image/resize,w_44,h_57', new BMap.Size(44, 57)) // eslint-disable-line
            },
            left_bottom_latitude: '', // 地图左下角-纬度
            left_bottom_longitude: '', // 地图左下角-经度
            right_top_latitude: '', // 右上角纬度
            right_top_longitude: '', // 右上角经度
            markerArr: [], // 地图标记数组
        }
    },
    created () {

    },
    activated () {

    },
    mounted () {
    },
    methods: {
        // 初始化地图
        initBaiduMap () {
            /* eslint-disable */
            // 百度地图API功能
            let _this = this
            // 初始化地图
            _this.baidu_map = new BMap.Map('allmap', { minZoom: 11 })
            let point = new BMap.Point(_this.position.longitude || '113.332926', _this.position.latitude || '23.202723')
            _this.baidu_map.centerAndZoom(point, 14)
            _this.baidu_map.disableDoubleClickZoom(true) // 禁止双击放大
            _this.baidu_map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放功能。仅对PC上有效
            // 当前定位maker
            let marker = new BMap.Marker(point, { icon: _this.map_icon.selfIcon })
            _this.baidu_map.addOverlay(marker)
            // 获取半径
            this.getBoundsCoord().then(() => {
                _this.getAllList() // 获取数据
            })
            // 滑动地图
            _this.baidu_map.addEventListener('dragend', function () {
                _this.getBoundsCoord().then(() => { // 矩形坐标
                    _this.getAllList() // 获取数据
                })
            })
            // 缩放地图
            _this.baidu_map.addEventListener('zoomend', function () {
                _this.getBoundsCoord().then(() => { // 矩形坐标
                    _this.getAllList() // 获取数据
                })
            })
            /* eslint-disable */
        },
        // 获取地图可视范围的四个角的坐标
        getBoundsCoord() {
            /* eslint-disable */
            let _this = this
            return new Promise((resolve, reject) => {
                let bounds = _this.baidu_map.getBounds() // 获取当前矩形
                // _this.left_bottom_longitude = bounds.Ul.lng // 左下-经度
                // _this.left_bottom_latitude = bounds.Ul.lat // 左下-纬度
                // _this.right_top_longitude = bounds.Dl.lng // 右上-经度
                // _this.right_top_latitude = bounds.Dl.lat // 右上-纬度
                // _this.left_bottom_longitude = bounds.El.lng // 左下-经度
                // _this.left_bottom_latitude = bounds.El.lat // 左下-纬度
                // _this.right_top_longitude = bounds.Vl.lng // 右上-经度
                // _this.right_top_latitude = bounds.Vl.lat // 右上-纬度
                _this.left_bottom_longitude = bounds.Il.lng // 左下-经度
                _this.left_bottom_latitude = bounds.Il.lat // 左下-纬度
                _this.right_top_longitude = bounds.Yl.lng // 右上-经度
                _this.right_top_latitude = bounds.Yl.lat // 右上-纬度
                resolve()
            })
            /* eslint-disable */
        },
        // maker绘制
        getMarkerData() {
            let newMakerArr = [] // 增量标记
            if (!this.markerArr.length) { // 首次加载
                newMakerArr = this.allStoreList
            } else {
                this.allStoreList.forEach(itemArr => {
                    let obj = itemArr
                    let isExist = false
                    this.markerArr.forEach(oldMarkerArr => {
                        if (itemArr.id === oldMarkerArr.id) {
                            isExist = true
                        }
                    })
                    if (!isExist) {
                        newMakerArr.push(obj)
                    }
                })
            }
            this.markerArr = this.markerArr.concat(newMakerArr) // 把增量的数据push进来
            newMakerArr.forEach(item => {
                let point = new BMap.Point(item.longitude, item.latitude)
                let marker = new BMap.Marker(point, { icon: item.id === this.markerArr[0].id ? this.map_icon.nearIcon : this.map_icon.ohterIcon })
                this.baidu_map.addOverlay(marker)
                marker.id = item.id
                marker.addEventListener("click", (e) => {
                    // this.goSpecialActivity(marker.id)// 跳转活动详情
                    this.goPage('goodsList', marker.id, {latitude: this.position.latitude, longitude: this.position.longitude})
                });
            });
        },
        /* 重置地图位置 */
        onResetMap() {
            this.baidu_map.panTo(new BMap.Point(this.position.longitude, this.position.latitude))
        },
        // 获取全部门店
        getAllList () {
            let param = {
                topic_id: this.$route.query.topic_id,
                topic_type: this.topictype,
                store_id: this.$route.query.store_id, // 商家id
                latitude: this.position.latitude || '23.202723',
                longitude: this.position.longitude || '113.332926',
                // left_bottom_latitude: this.left_bottom_latitude,
                // left_bottom_longitude: this.left_bottom_longitude,
                // right_top_latitude: this.right_top_latitude,
                // right_top_longitude: this.right_top_longitude
                left_bottom_latitude: this.right_top_latitude,
                left_bottom_longitude: this.right_top_longitude,
                right_top_latitude: this.left_bottom_latitude,
                right_top_longitude: this.left_bottom_longitude
            }
            getPromotionStoreInfo(param).then(res => {
                this.all_store_list_count = res.count
                this.allStoreList = res.list
                this.getMarkerData() // maker绘制
            })
        },
        goPage (type, sstore_id, position) {
            const params = { type, value: {...this.position} }
            sstore_id && (params.value.sstore_id = sstore_id)
            position && (Object.assign(params.value, position))
            if (type === 'list' || type === 'map') {
                Object.assign(params.value, {is_map: type === 'map'})
                params.cb = this.goStoreList
            } else if (type === 'goodsList') {
                params.cb = this.goSingularGoodsList
            } else {
                params.cb = this.onResetMap
            }
            this.$emit('callback', params)
        },
        goStoreList (query) {
            // 跳转门店列表
            this.$router.push({
                path: '/storeList',
                query
            })
        },
        goSingularGoodsList (query) {
            this.$router.push({
                path: '/customSingularGoodsList',
                query
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "../../../assets/stylus/variables";

.promotionMap-component
    position relative
    width 100%
    .top-info
        box-sizing border-box
        width 100%
        height 88px
        padding 0 24px 0 24px
        background $fcWhite
        display flex
        justify-content space-between
        align-items center
        font-size 28px
        .text
            color #333
            .number
                color $fcRed
                margin 0 6px
        .map-model
            // width 160px
            padding  0 23px
            height 60px
            border 0
            color $fcWhite
            background-color $fcRed
            border-radius 30px
            font-size 28px
    .map
        width 100%
        height 470px
        overflow hidden
    .reset
        height 54px
        position absolute
        bottom 60px
        left 25px
        display block
        width 54px
        border-radius 54px
        background-color $fcWhite
        z-index 10
        box-shadow 0px 8px 18px 0px rgba(15, 135, 234, 0.27)
        .ico
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -50%)
    .enlarge
            display block
            width 84px
            height 84px
            position absolute
            bottom 30px
            right 25px
            border-radius 54px
            z-index 10
</style>
